module.exports = __webpack_public_path__ + "betting_square-76f1ca0f9a071c3a0418d01c3feda5b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/fi/betting_square.jpg
// module id = 1172
// module chunks = 1 2